import { Component, OnDestroy, ViewEncapsulation } from '@angular/core'
import { NotificationsService } from 'src/app/shared/service/notifications/notifications.service'
import { SubSink } from 'subsink'
import { Notification } from '../model/notification'
import { NotificationUtilityService } from './service/notification.utility.service'
import { RfAuthenticationService } from 'src/app/authentication/rf-authentication.service'
import { StorageService } from 'src/app/shared/service/storage/storage.service'
import { CommonModule } from '@angular/common'
import { MaterialModule } from 'src/app/shared/module/material.module'

@Component({
	selector: 'ald-notification',
	templateUrl: './notification.component.html',
	styleUrls: ['./notification.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: true,
	imports: [
		CommonModule,
		MaterialModule
	],
	providers: [NotificationsService]
})
export class NotificationComponent implements OnDestroy {
	private subs = new SubSink()
	numNotifications = 0
	h = null

	constructor(private s: NotificationsService, private storage: StorageService) {
		//this.polling();
		this.h = setInterval(() => {
			this.subs.unsubscribe()
			this.polling()
		}, 900000)
	}

	polling() {
		const isOffline = this.storage.getSessionStorage('offline')
		if (!isOffline) {
			this.subs.add(this.s.getUnreadNotifications().subscribe((value) => (this.numNotifications = value)))
		}
	}

	ngOnDestroy() {
		clearInterval(this.h)
		this.subs.unsubscribe()
	}
}
